'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './overview.routes';

export class ForumOverviewComponent {
  constructor($state, Auth, ForumService, $uibModal, StorageService, Config) {
    'ngInject';

    var forumConfig = Config.getModuleConfig(Config.Modules.Forum);
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ForumService = ForumService;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.StorageService = StorageService;

    this.isAdmin = Auth.isAdminSync;
    this.userId = Auth.getCurrentUserSync()._id;

    this.catKeys = forumConfig.getCategoryKeys();
    this.catDefs = forumConfig.getCategories();

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Forum");

    this.data = {};

    this.reloadData();
  }

  isCreator(data) {
    return data.meta.creationUser._id == this.userId;
  }

  reloadData() {
    this.catKeys.forEach(key => {
      this.ForumService.queryByCategory({cat: key}, data => {
        this.data[key] = data;
      })
    });
  }

  getPreviewText(value) {
    let limit = 300;

    if (value) {

      let modifiedValue = value.replace(/<.+?>/g, ' ');

      if (value.length > limit) {

        modifiedValue = modifiedValue.substring(0, limit);
        modifiedValue = `${modifiedValue.substring(0, modifiedValue.lastIndexOf(' '))} …`;

      }

      return modifiedValue;

    }

    return value;
  }

}

export default angular.module('conduuApp.forumOverview', [uiRouter])
  .config(routes)
  .component('forumOverview', {
    template: require('./overview.html'),
    controller: ForumOverviewComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/forum/overview/overview.component.js